var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { parseColorGradients } from '../../../Utils/UtilityFunctions';
import ProgressBarSkeleton from '../skeleton/ProgressBarSkeleton';
var ProgressBar = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 5px;\n  border-radius: 8px;\n  width: 100%;\n  background: linear-gradient(to right, ", " );\n  background-color: ", ";\n"], ["\n  height: 5px;\n  border-radius: 8px;\n  width: 100%;\n  background: linear-gradient(to right, ", " );\n  background-color: ", ";\n"])), function (props) { return props.background; }, function (props) { return props.singleColor; });
var defaultProps = {
    load: false,
};
var AlertsProgressTriggers = function AlertsProgressTriggers(props) {
    var _a = useState(''), colors = _a[0], setColors = _a[1];
    var load = props.load, pulse = props.pulse;
    useEffect(function () {
        if ((pulse === null || pulse === void 0 ? void 0 : pulse.length) > 0) {
            setColors(parseColorGradients(pulse));
        }
    }, [pulse]);
    return (_jsx("div", __assign({ className: "progress-wrapper" }, { children: load ? _jsx(ProgressBarSkeleton, {})
            : _jsx(ProgressBar, { background: pulse.length > 1 ? colors : '', singleColor: colors }) })));
};
AlertsProgressTriggers.defaultProps = defaultProps;
export default AlertsProgressTriggers;
var templateObject_1;
